import HqTable from './HqTable.vue'

// export function install (Vue, options = {}) {
// 	if (install.installed) return
// 	install.installed = true

// 	Vue.directive('hqtable', HqTable)
// }

export default HqTable;


// WEBPACK FOOTER //
// ./src/lib/v-hqtable/lib/index.js